/**
 * Akito Media — demo vendor for catalog seeding. Connect Stripe via vendor onboarding
 * after switching to a new platform Stripe account (old connected account IDs are invalid).
 */
export const AKITO_CONNECT_VENDOR = {
  /** Stable user id used in Supabase after catalog seed. */
  userId: 'a1111111-1111-4111-8111-111111111101',
  stripeAccountId: null as string | null,
  businessName: 'Akito Media',
  contactName: 'Amjad Hussain',
  email: 'contact@akitomedia.co.uk',
  country: 'GB',
  currency: 'GBP',
} as const;

export const AKITO_PRODUCT_IMAGE_BASE = `${process.env.PUBLIC_URL ?? ''}/vendors/akito-media`;
